const secondLevelOpenerELs = document.querySelectorAll(
  '.nav-item--has_child > a .expand'
);

secondLevelOpenerELs.forEach((secondLevelOpenerEL) => {
  const itemMainNavEL = secondLevelOpenerEL.parentElement;
  const submenuEL = itemMainNavEL.nextElementSibling;
  const openSubmenu = () => {
    event.preventDefault();
    if (!secondLevelOpenerEL.classList.contains('expand--open')) {
      secondLevelOpenerEL.classList.add('expand--open');
      submenuEL.style.display = 'block';
    } else {
      secondLevelOpenerEL.classList.remove('expand--open');
      submenuEL.style.display = 'none';
    }
  };
  secondLevelOpenerEL.addEventListener('click', () => openSubmenu(event));
});
